import { responsive } from '../../utils/helpers';

const breakpoint = 2

const layout = {
  flexDirection: 'column',
  flexWrap: 'wrap',
}

const text = {
  flexWrap: 'wrap',
  lineHeight: 'body',
}

const style = {

  message: {
    textAlign: 'center'
  },
  layout: layout,
  listOne: {
    ...layout,
    alignItems: 'flex-end'
  },
  listTwo: {
    ...layout,
    alignItems: 'flex-start'
  },
  text: text,
  reverse: {
    ...text,
    alignItems: 'left',
    flexDirection: 'row-reverse',
    textAlign: 'right'
  },
  bold: {
    fontWeight: 700,
    width: responsive('100%', 'auto', breakpoint)
  }
}

export default style
